// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductDetailsLink_container__qUfXR","link":"ProductDetailsLink_link__mAQy0"};